import styled from 'styled-components';

export const FormUploadSetImageStyled = styled.div`
  .lbl_g {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
    .lbl_ca {
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
    }
    .s_g_txt {
      font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
      color: ${({ theme }) => theme.COLORS.GRAY_24};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    }
  }
  .err_img {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    color: ${({ theme }) => theme.COLORS.RED_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    text-align: center;
    margin-top: 8px;
  }
`;

export default FormUploadSetImageStyled;
